@if (formPlanner) {
  <div class="box p-2 gap-2" [formGroup]="formPlanner">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'name' | translate }}</mat-label>
      <input
        matInput
        name="name"
        (focusout)="formPlanner.controls.name.markAsTouched()"
        [formControl]="formPlanner.controls.name"
      />
      @if (formPlanner.controls.name.touched && formPlanner.controls.name.invalid) {
        <mat-hint class="text-danger">
          @if (formPlanner.controls.name.errors?.['required']) {
            {{ 'field_cannot_be_empty' | translate }}
          }
        </mat-hint>
      }
    </mat-form-field>
    <div>
      @if (!planners.length && modalType === 'ADVERT') {
        <app-dropdown
          bindValue="value"
          placeholder="{{ 'type_of_scheduler' | translate }}"
          [closeOnSelect]="true"
          [items]="typePlanners"
          [formControl]="formPlanner.controls.x_data.controls.type"
          [disabled]="!!planner_id"
          (focusout)="formPlanner.controls.x_data.controls.type.markAsTouched()"
          class="mb-3"
        ></app-dropdown>
      }
      @if (formPlanner.controls.x_data.controls.type.touched && formPlanner.controls.x_data.controls.type.invalid) {
        <mat-hint class="text-danger">
          @if (formPlanner.controls.x_data.controls.type.errors?.['required']) {
            {{ 'field_cannot_be_empty' | translate }}
          }
        </mat-hint>
      }
    </div>
    @if (
      !planners.length &&
      (modalType === 'PACKET' || modalType === 'ADS' || modalType === 'CREATE_ADVERT' || modalType === 'ADVERT')
    ) {
      <app-dropdown
        bindValue="value"
        placeholder="{{ 'status_of_scheduler' | translate }}"
        [closeOnSelect]="true"
        [items]="statusPlanners"
        [formControl]="formPlanner.controls.x_data.controls.status"
        class="mb-3"
      ></app-dropdown>
    }
    <mat-form-field appearance="outline">
      <mat-label>Оберіть дату</mat-label>
      <input
        name="date_field"
        matInput
        [min]="today"
        [matDatepicker]="picker"
        [readonly]="true"
        [formControl]="formPlanner.controls.x_data.controls.date"
        (dateChange)="addDate('change', $event)"
        (dateInput)="addDate('input', $event)"
        (focusout)="formPlanner.controls.x_data.controls.date.markAsTouched()"
      />
      <mat-hint [hidden]="true">DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker [disabled]="false" #picker></mat-datepicker>
      @if (formPlanner.controls.x_data.controls.date.touched && formPlanner.controls.x_data.controls.date.invalid) {
        <mat-hint class="text-danger">
          @if (formPlanner.controls.x_data.controls.date.errors?.['required']) {
            {{ 'field_cannot_be_empty' | translate }}
          }
        </mat-hint>
      }
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Оберіть час</mat-label>
      <input
        matInput
        mask="Hh:m0"
        [formControl]="formPlanner.controls.x_data.controls.time"
        [showMaskTyped]="true"
        [dropSpecialCharacters]="false"
        [shownMaskExpression]="'__:__'"
        (focusout)="formPlanner.controls.x_data.controls.time.markAsTouched()"
      />
      @if (formPlanner.controls.x_data.controls.time.touched && formPlanner.controls.x_data.controls.time.invalid) {
        <mat-hint class="text-danger">
          @if (formPlanner.controls.x_data.controls.time.errors?.['required']) {
            {{ 'field_cannot_be_empty' | translate }}
          }
        </mat-hint>
      }
      @if (formPlanner.controls.x_data.controls.time.invalid) {
        <mat-hint class="text-danger">
          @if (formPlanner.controls.x_data.controls.time.errors?.['minlength']) {
            {{ 'planner_min_min_length' | translate }}
          }
        </mat-hint>
      }
    </mat-form-field>
    @if (this.adverts) {
      <app-dropdown
        label="{{ 'step' | translate }}"
        [items]="eachTimes"
        bindValue="value"
        [formControl]="formPlanner.controls.x_data.controls.step"
        [closeOnSelect]="true"
        class="mb-3"
      >
      </app-dropdown>
    }
    <div class="d-flex gap-2 align-self-end">
      <app-button [customClass]="'bg-danger'" (onChangeClick)="onClose()">{{ 'cancel' | translate }}</app-button>
      <app-button [disabled]="formPlanner.invalid" (onChangeClick)="onSave()">{{ 'save' | translate }}</app-button>
    </div>
  </div>
}
